<template>
    <div class="profile">


        <router-view></router-view>
    </div>
</template>

<script>
  // @ is an alias to /src

  export default {
    name: 'Profile',
    components: {},
    data: function () {
      return {}
    },
    mounted: function () {
    },
    computed: {},
    methods: {}
  }
</script>
